var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveMeals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0161 8.98979L22.2017 3.79698",
    stroke: "#2C75C5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9035 13.5093C15.2876 13.4132 15.5757 13.4132 15.9599 13.317C17.2082 13.2208 18.6487 12.5477 20.0892 11.1053L24.7947 6.39326",
    stroke: "#2C75C5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37293 15.9138L1.65079 21.3951C0.594453 22.1644 0.49842 23.703 1.45873 24.5685C2.41903 25.5301 3.85949 25.3378 4.62773 24.3761L10.1015 17.5486",
    stroke: "#2C75C5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6088 1.2007L14.8072 5.91269C13.3668 7.35514 12.5985 8.79759 12.5985 10.0477C12.5985 10.4324 12.5025 10.7209 12.4065 11.1055",
    stroke: "#2C75C5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80354 10.3361C0.306748 7.83583 0.306748 3.89314 2.80354 1.3929L13.4629 12.067L17.0161 15.625L22.4898 21.1063C23.4501 22.068 23.4501 23.5104 22.4898 24.4721C21.5295 25.4337 19.8009 25.4337 18.9367 24.2797L14.9994 19.3754C14.0391 18.1253 12.3106 17.7406 10.7741 18.3176L2.80354 10.3361Z",
    fill: "#2C75C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMeals);
export default __webpack_public_path__ + "static/media/active-meals.0d6f6065a3d203daac5c8fd697020b5f.svg";
export { ForwardRef as ReactComponent };